import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MultimediaState {
    elements: MultimediaElement[],
    currentPage: number,
    rowsPerPage: number,
    totalRows: number,
    sort:string[],
    loading: boolean
}

export interface MultimediaElement {
    _id:string,
    name: string,
    base64EncodedContent: string,
    type: string,
    entityType: string,
    entityId: string
}
interface PageableDto {
    page: number;
    size: number;
    sort: string[];
}

export interface GetAllElementPayloadMulti {
    pageableDto: PageableDto
}

const initialState: MultimediaState = {
    elements: [],
    currentPage: 0,
    rowsPerPage: 10,
    totalRows: 0,
    sort: ['dateCreated', 'asc'],
    loading: false
}

export const Multimedia = createSlice({
    name: "multimedia",
    initialState,
    reducers: {
        getAllElement: (state, action: PayloadAction<GetAllElementPayloadMulti>) => {
            state.loading = true;
        },
        getAllElementSuccess: (state, action: PayloadAction<{ data: MultimediaElement[],
            currentPage: number, totalRows: number }>) => {
            state.elements = action.payload.data;
            state.currentPage = action.payload.currentPage;
            state.totalRows = action.payload.totalRows;
            state.loading = false;
        },
        getAllElementError: (state) => {
            state.loading = false;
        },
        setPage:(state, action:PayloadAction<number>) => {
            state.currentPage = action.payload;
        },
        setRowsPerPage:(state, action: PayloadAction<number>) => {
            state.rowsPerPage = action.payload;
        },
        setSort:(state, action: PayloadAction<string[]>) =>{
             state.sort = action.payload;
        },

        saveElement: (state, action: PayloadAction<MultimediaElement>) => {},
        saveElementSuccess: (state, action: PayloadAction<MultimediaElement>) => {
            state.elements.push(action.payload);
        },
        saveElementError: (state) => {state.loading = false;},

        deleteElement: (state, action: PayloadAction<{id:string,callback: () => void}>) => {},
        deleteElementSuccess: (state, action: PayloadAction<string>) => {
            state.elements = state.elements.filter(element => element._id !== action.payload);
        },
        deleteElementError: (state) => {state.loading = false;},
    }
});

export const {
    getAllElement,
    getAllElementSuccess,
    getAllElementError,
    saveElement,
    saveElementSuccess,
    saveElementError,
    deleteElement,
    deleteElementSuccess,
    deleteElementError
} = Multimedia.actions;

export default Multimedia.reducer;
